import { useEffect, useState, useCallback, useMemo, useContext, } from 'preact/compat';
import { getDayOfYear, getYear, isValid, parse, parseISO, } from 'date-fns';
import useWindowResize from 'beautiful-react-hooks/useWindowResize';
import useDebouncedCallback from 'beautiful-react-hooks/useDebouncedCallback';
export default function useDatepickerConfig(props) {
    const { toDate, fromDate, layout, options, } = props;
    const { monthsShown: initialMonthsShown } = useContext(options);
    const onWindowResize = useWindowResize();
    const parseDate = (date) => {
        const trimmedDate = date.trim();
        // ISO or ISO-like (e.g., 2025-11-06T00:00:00 or 2025-11-06T00:00:00+00:00)
        const isoLike = /^\d{4}-\d{2}-\d{2}T/;
        if (isoLike.test(date) && isValid(parseISO(date))) {
            return parseISO(date);
        }
        let formattedDate = parse(trimmedDate, 'yyyy-MM-dd', new Date());
        if (isValid(formattedDate))
            return formattedDate;
        formattedDate = parse(trimmedDate, 'dd/MM/yyyy', new Date());
        if (isValid(formattedDate))
            return formattedDate;
        return new Date();
    };
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
    const [monthsShown, setMonthsShown] = useState(initialMonthsShown);
    const [isAfterNov, setIsAfterNov] = useState(false);
    const [isAfterDec, setIsAfterDec] = useState(false);
    const [minDate, setMinDate] = useState(parseDate(fromDate));
    const [maxDate] = useState(parseDate(toDate));
    const [isStillLastYear, setIsStillLastYear] = useState(false);
    const [usedYear, setUsedYear] = useState(new Date().getFullYear());
    // const useOneMonth = useMemo(() => layout === 'product' || layout === 'vertical' || layout === 'rework', [layout]);
    const isWW = useMemo(() => layout === 'winter-wonderland' || layout === 'horizontal', [layout]);
    const calculateIfIsStillLastYear = useCallback(() => {
        const currDate = new Date();
        const currDayOfYear = getDayOfYear(currDate);
        const currYear = getYear(currDate);
        if (toDate) {
            const maxDateObj = parseDate(toDate);
            const maxDay = getDayOfYear(maxDateObj);
            const maxYear = getYear(maxDateObj);
            setIsStillLastYear(maxYear === currYear && currDayOfYear <= maxDay);
        }
        else {
            setIsStillLastYear(false);
        }
    }, [toDate]);
    // const calculateMonthsShown = useCallback(() => {
    //   // At this point we already know is isAfterDec/Nov is already sit so don't go any further than this
    //   if (useOneMonth || (isWW && isAfterDec)) {
    //     return setMonthsShown(1);
    //   }
    //
    //   if (isWW && isAfterNov) {
    //     return setMonthsShown(2);
    //   }
    //
    //   if (!formattedAvailableDates.length) {
    //     return;
    //   }
    //
    //   if (isStillLastYear) {
    //     return setMonthsShown(1);
    //   }
    //
    //   const currDate = new Date();
    //   const currYear = currDate.getFullYear();
    //
    //   const swwYear = minDate.getFullYear();
    //   const currDateAfterNov = isAfter(currDate, endOfMonth(new Date(swwYear, 10, 1))); // NOTE: MonthIndex Should be 10
    //   const currDateAfterDec = isAfter(currDate, endOfMonth(new Date(swwYear, 11, 1))); // MonthIndex 11 = December
    //
    //   setIsAfterNov(currDateAfterNov);
    //   setIsAfterDec(currDateAfterDec);
    //
    //   if (isWW && currDateAfterDec) {
    //     // If after December, set minDate to January 1st of the year after minDate's year and show 1 month
    //     setMinDate(new Date(swwYear + 1, 0, 1));
    //     return setMonthsShown(1);
    //   }
    //
    //   if (isWW && currDateAfterNov) {
    //     // setting 2 months shown if the date is after November (i.e., in December), based on minDate's year
    //     setMinDate(new Date(minDate.getFullYear(), 11, 1));
    //     return setMonthsShown(2);
    //   }
    //
    //   return setMonthsShown(initialMonthsShown);
    // }, [formattedAvailableDates, initialMonthsShown, isStillLastYear, isWW, minDate, monthsShown, useOneMonth]);
    const calculateUsedYear = useCallback(() => {
        const currDate = new Date();
        const currYear = currDate.getFullYear();
        setUsedYear(isStillLastYear ? (currYear - 1) : currYear);
    }, [isStillLastYear]);
    const handleWindowResize = useDebouncedCallback(() => setIsMobile(window.innerWidth < 992));
    useEffect(calculateIfIsStillLastYear, [toDate, calculateIfIsStillLastYear]);
    useEffect(calculateUsedYear, [isStillLastYear, calculateUsedYear]);
    // useEffect(calculateMonthsShown, [calculateMonthsShown, formattedAvailableDates, isStillLastYear]);
    onWindowResize(handleWindowResize);
    return {
        isMobile,
        isWinterWonderland: isWW,
        monthsShown,
        isAfterNov,
        isAfterDec,
        minDate,
        maxDate,
        isStillLastYear,
        usedYear,
    };
}
